module.exports = __webpack_public_path__ + "static/olive2-5cb39b30f829ed3aa7d3824fe71781e6.jpg";